import { Hammer } from "flowbite-react-icons/solid";
import { useMemo, useState } from "preact/hooks";
import PropTypes from "prop-types";
import YesNoInput from "@/components/input/yes-no.input.jsx";
import CustomizeSection from "@/components/overlays/shared/customize-section.jsx";

DevCustomizeOptions.propTypes = {
  config: PropTypes.object,
  setConfigState: PropTypes.func.isRequired,
  children: PropTypes.node,
};
export default function DevCustomizeOptions({ config, setConfigState, children }) {
  const splitHost = window.location.host.split(".");
  const [showOptions, setShowOptions] = useState(false);
  const collapseClassName = useMemo(() => {
    return showOptions ? "collapse-open" : "collapse-close";
  }, [showOptions]);

  let environment = "prod";

  if (splitHost.length > 1) {
    const hostEnvironment = splitHost[1];

    switch (hostEnvironment) {
      case "dev":
      case "qa":
        environment = hostEnvironment;
        break;
      case "experience":
        environment = "prod";
    }
  } else {
    environment = import.meta.env.VITE_APP_ENV;
  }

  const showDonationsOption = Object.hasOwn(config, "showAllDonations");

  const showDebugOption = Object.hasOwn(config, "debugMode");

  if (environment !== "dev" || (!showDonationsOption && !showDebugOption && !children)) {
    return null;
  }

  return (
    <>
      <div tabIndex={-1} className={`collapse ${collapseClassName}`}>
        <div className="collapse-content p-0">
          <div className="user-select-none mb-4">
            <CustomizeSection title="Developer Options">
              {showDonationsOption && (
                <YesNoInput
                  currentValue={config.showAllDonations}
                  name="showAllDonations"
                  onChange={setConfigState}
                  mode="checkbox"
                  label="Show all donations from campaign"
                />
              )}

              {showDebugOption && (
                <YesNoInput
                  currentValue={config.debugMode}
                  name="debugMode"
                  onChange={setConfigState}
                  mode="checkbox"
                  label="Enable debug mode"
                />
              )}
              {children}
            </CustomizeSection>
          </div>
        </div>
      </div>

      <div
        data-tip="Dev Customization Options"
        className="tooltip tooltip-left fixed z-100 bottom-3 right-18"
      >
        <button
          type="button"
          className="btn btn-secondary btn-circle"
          onClick={() => setShowOptions((prevState) => !prevState)}
        >
          <Hammer />
        </button>
      </div>
    </>
  );
}
